import script from "./StatePowerConsumersQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./StatePowerConsumersQuestion.vue?vue&type=script&setup=true&lang=js"

import _style_0 from "./StatePowerConsumersQuestion.vue?vue&type=style&index=0&id=6d2f5a20&inline&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]],['__scopeId',"data-v-6d2f5a20"]])

export default __exports__